@if (selectedGuardUpdateHistoryList?.length) {
  <div class="user-stat-card">
    <div id="heading">
      <dt class="mb-2">Location History</dt>
    </div>

    <div class="row row-cols-1 row-cols-md-2">
      <div class="col d-flex flex-column">
        <div class="order-2 order-lg-1">
          <gtapp-leaflet-trail-map
            [routeData]="visibleEventsMappedList"
            [zoomInEvent]="selectedUpdate"
          ></gtapp-leaflet-trail-map>
        </div>

        <div class="order-1 order-lg-2">
          <table class="table">
            <tbody>
              <tr>
                <td>Total No. of Updates</td>
                <td>
                  {{ selectedGuardUpdateHistoryList?.length }}
                </td>
              </tr>
              @if (guardStats?.avgUpdatePerDay) {
                <tr>
                  <td>Ave. No. Updates Per Day</td>
                  <td>
                    {{ guardStats?.avgUpdatePerDay?.toFixed(0) }}
                  </td>
                </tr>
              }
              <tr>
                <td>Total Distance Travelled (km)*</td>
                <td>
                  {{ guardStats?.totalDistance?.toFixed(2) }}
                </td>
              </tr>
              @if (guardStats?.avgDistancePerDay) {
                <tr>
                  <td>Ave. Distance Travelled Per Day (km)*</td>
                  <td data-label="Distance (KM)">
                    {{ guardStats?.avgDistancePerDay?.toFixed(2) }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div class="fst-italic small">* Line of sight</div>
        </div>
      </div>

      <div class="shadow border">
        <div id="events-container" #eventsContainer>
          <div class="p-2">
            @for (
              update of selectedGuardUpdateHistoryList;
              track update?.id;
              let i = $index
            ) {
              <!-- Date Header -->
              @if (
                i === 0 ||
                (selectedGuardUpdateHistoryList[i - 1].updated_at
                  | misc: "eventDateGrouping") !==
                  (update?.updated_at | misc: "eventDateGrouping")
              ) {
                <div class="fw-semibold position-sticky top-0 z-1 rounded">
                  <div
                    class="text-end grouped-date p-2 py-3 pe-4 fs-5 fw-normal"
                  >
                    {{ update?.updated_at | misc: "eventDateGrouping" }}
                  </div>
                  <!-- <div
                    class="accordion accordion-flush"
                    id="dailyStatAccoridan"
                  >
                    <div class="accordion-item p-2">
                      <div class="accordion-header">
                        <button
                          class="collapsed rounded accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          aria-expanded="false"
                          [attr.data-bs-target]="
                            '#flush-collapse' + update?.updated_at
                          "
                          [attr.aria-controls]="
                            'flush-collapse' + update?.updated_at
                          "
                        >
                          {{ update?.updated_at | misc: "eventDateGrouping" }}
                        </button>
                      </div>

                      <div
                        [id]="'flush-collapse' + update?.updated_at"
                        class="accordion-collapse collapse"
                        data-bs-parent="#dailyStatAccoridan"
                      >
                        <div class="accordion-body fw-light px-0">
                          <div class="d-flex gap-4">
                            <div
                              class="d-flex flex-column gap-2 align-items-center"
                            >
                              <div>Distance Covered</div>
                              <div>
                                {{
                                  guardStats?.updatesByDate?.[
                                    (update?.updated_at
                                      | misc: "eventDateGrouping")
                                  ]?.distance?.toFixed(2)
                                }}
                                Km
                              </div>
                            </div>
                            <div
                              class="d-flex flex-column gap-2 align-items-center"
                            >
                              <div>Updates</div>
                              <div>
                                {{
                                  guardStats?.updatesByDate?.[
                                    (update?.updated_at
                                      | misc: "eventDateGrouping")
                                  ]?.updateCount
                                }}
                              </div>
                            </div>
                            @if (
                              guardStats?.updatesByDate?.[
                                (update?.updated_at | misc: "eventDateGrouping")
                              ]?.patrolUpdateCount
                            ) {
                              <div
                                class="d-flex flex-column gap-2 align-items-center"
                              >
                                <div>Patrol</div>
                                <div>
                                  {{
                                    guardStats?.updatesByDate?.[
                                      (update?.updated_at
                                        | misc: "eventDateGrouping")
                                    ]?.patrolUpdateCount
                                  }}
                                </div>
                              </div>
                            }
                            @if (
                              guardStats?.updatesByDate?.[
                                (update?.updated_at | misc: "eventDateGrouping")
                              ]?.jobUpdateCount
                            ) {
                              <div
                                class="d-flex flex-column gap-2 align-items-center"
                              >
                                <div>Job</div>
                                <div>
                                  {{
                                    guardStats?.updatesByDate?.[
                                      (update?.updated_at
                                        | misc: "eventDateGrouping")
                                    ]?.jobUpdateCount
                                  }}
                                </div>
                              </div>
                            }
                            @if (
                              guardStats?.updatesByDate?.[
                                (update?.updated_at | misc: "eventDateGrouping")
                              ]?.incidentUpdateCount
                            ) {
                              <div
                                class="d-flex flex-column gap-2 align-items-center"
                              >
                                <div>Incident</div>
                                <div>
                                  {{
                                    guardStats?.updatesByDate?.[
                                      (update?.updated_at
                                        | misc: "eventDateGrouping")
                                    ]?.incidentUpdateCount
                                  }}
                                </div>
                              </div>
                            }

                            <div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              }

              <div
                class="p-2 bg-secondary-subtle mb-2 border rounded"
                #eventsList
                [attr.data-index]="i"
                [attr.role]="
                  update?.gps?.lat && update?.gps?.lon ? 'button' : ''
                "
                (click)="
                  update?.gps?.lat && update?.gps?.lon
                    ? zoomIntoMap(update)
                    : ''
                "
              >
                <div class="d-flex column-gap-4 row-gap-2 text-dark mb-2">
                  <div>
                    {{ update?.updated_at | date: "HH:mm:ss" }}
                  </div>
                  <div class="flex-grow-1">
                    <div class="text-secondary">
                      {{ update?.event_type }}
                      @if (update?.action) {
                        <div>[{{ update?.action }}]</div>
                      }
                    </div>
                  </div>

                  <div>
                    <div class="fw-semibold flex-grow-1">
                      {{ update?.site_name }}
                    </div>

                    <div>
                      {{ update?.company_name }}
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-center gap-2">
                  <div>
                    @if (update?.gps?.lat && update?.gps?.lon) {
                      <button
                        class="btn btn-outline-primary btn-sm"
                        (click)="zoomIntoMap(update)"
                      >
                        Show on Map
                      </button>
                    }
                  </div>

                  <button class="btn btn-outline-primary btn-sm" >
                    Show Details
                  </button>
                </div> -->
              </div>
            }
          </div>
        </div>
        @if (moreEventsAvailable) {
          <div class="my-3 text-center">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              (click)="getUserUpdateLog(true)"
            >
              Load More
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
